import React from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import ModalsCloseIcon from '../Icons/ModalsCloseIcon.js';

var css_248z = ".A4oou{display:flex}[dir] .A4oou{cursor:pointer}";
var styles = {"modal_closeButton":"A4oou"};
styleInject(css_248z);

const ModalCloseButton = ({ closeModal }) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.modal_closeButton, onClick: closeModal }, /* @__PURE__ */ React.createElement(ModalsCloseIcon, null));
};

export { ModalCloseButton as default };
//# sourceMappingURL=ModalCloseButton.js.map
